var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Vlt-switch",class:{'Vlt-switch--red': _vm.red, 'Vlt-switch--small': _vm.small},attrs:{"id":_vm.id}},[_c('label',[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.checked},on:{"change":_vm.onChange}}),_c('span',{staticClass:"Vlt-switch__slider",on:{"click":function($event){$event.stopPropagation();}}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }